  <!--
   功能名称:千里眼平台(技师)-会员管理
   开发人:梁高权
   创建时间:2021/03/14
   最后修改时间:2021/03/14
   -->
<template>
  <div class="member-wrap">
    <!-- 下拉菜单筛选 -->
    <DropdownMenu :param="param" @updateParam="updateParam" @onReset="reset"/>
    <!-- 搜索框 -->
    <div class="search">
      <div class="search-box">
        <van-field v-model="param.phone" type="digit" maxlength="11" placeholder="输入会员手机号码"/>
        <van-icon name="search" size="19" @click="search" />
      </div>
    </div>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        offset="0"
      >
        <div class="Glist">
          <div class="title">
            <span>会员列表</span>
            <span>共找到<i>{{list.length}}人</i></span>
          </div>

          <div class="column" v-for="(item,index) in list" :key="index">
            <div class="caption">
              <div>{{item.phone|phoneFormat}}&nbsp;{{item.member_name.substring(0,4)}}</div>
              <div class="caption-icon">
                <van-icon @click="callPhone(item.phone)" :name="require('@/assets/images/phone.png')" size="25" />
                <van-icon @click="smsPhone(item.phone)" :name="require('@/assets/images/note.png')" size="25" />
              </div>
            </div>

            <div class="up">
              <div class="line">
                <div>上次消费时间</div>
                <div>{{item.last_consume_time|dateFormat}}</div>
              </div>
              <div class="line">
                <div>会员余额</div>
                <div>{{item.card_num}}元</div>
              </div>
            </div>

          <transition name="van-fade">
            <div class="middle" v-show="item.show">
              <div class="line">
                <div>会员卡号</div>
                <div>{{item.card_no}}</div>
              </div>
              <div class="line">
                <div>呢称<span style="color:#00CC99">*仅对自己可见</span></div>
                <div>{{item.member_nick|stringFormat}}</div>
              </div>
              <div class="line">
                <div>生日</div>
                <div class="birthday" @click="memberBlessing(item)"><van-icon  name="birthday-cake-o" color="#FF3366" size="22"/>{{item.member_birthday|dateFormat}}</div>
              </div>
              <div class="line" style="display: flex;flex-direction: column;">
                <div>爱好<span style="color:#00CC99">*仅对自己可见</span></div>
                <div style="text-align:justify;text-justify:newspaper;word-break:break-all">{{item.member_like}}</div>
              </div>
              <div class="line">
                <div>备注</div>
                <div>{{item.member_remark}}</div>
              </div>
            </div>
          </transition>

            <div class="below">
              <div v-if="!item.show" @click="item.show=true">展开更多&nbsp;<van-icon name="arrow-down"/></div>
              <div  v-else @click="item.show=false">收起&nbsp;<van-icon name="arrow-up"/></div>
              <div class="edit" @click="$router.push({path: 'memberEdit', query: {item}})" ><van-icon :name="require('@/assets/images/edit.png')" size="13" />编辑</div>
            </div>
          </div>

        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import table from '@/api/table'
export default {
  name: 'member',
  components: {
    'DropdownMenu':()=>import('./components/DropdownMenu')
  },
  filters: {
    // 格式化日期
    dateFormat(val){
      return (val||'').substring(0,4)+'年'+(val||'').substring(5,7)+'月'+(val||'').substring(8,10)+'日'
    },
    // 格式化字符
    stringFormat(val){
      let a='';if(val.length>10){a=val.substring(0,10)+'...'}else{a=val}
      return a
    },
    phoneFormat(val){
      // 替换指定范围的字符串
      function mask(str,begin,end,char){
       var fstStr = str.substring(0,begin);
       var lstStr = str.substring(end,str.length);
       return fstStr+char+lstStr
      }
      return mask(val,3,7,'****')
    }
  },
  data () {
    return {
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      param:{
        page:1,
        limit:5,
        before_birthday:-1,// 几天内生日(-1=>不作筛选 0=>当天生日的 1=>还有1天生日的)
        card_num:0,// 多少卡余额之内
        interval_day:0,// 多少天没来消费
        phone:''// 会员手机号码
      }
    }
  },
  methods: {
    // 调用拨号功能
    callPhone (phoneNumber) {location.href = 'tel://' + phoneNumber},
    smsPhone(phoneNumber){location.href = 'sms:' + phoneNumber+`?body=`},
    updateParam(val){
      this.param[Object.keys(val)[0]]=val[Object.keys(val)[0]]
      console.log(this.param)
      this.refreshing=true
      this.onRefresh()
    },
    reset(val){
      console.log(val)
      this.param={
        page:1,
        limit:5,
        before_birthday:-1,// 几天内生日(-1=>不作筛选 0=>当天生日的 1=>还有1天生日的)
        card_num:0,// 多少卡余额之内
        interval_day:0,// 多少天没来消费
        phone:''// 会员手机号码
      }
      this.refreshing=true
      this.onRefresh()
    },
    search(){
      this.refreshing=true
      this.onRefresh()
    },
    onLoad() {

        if (this.refreshing) {
          this.list = [];
          this.param.page=1;
          this.refreshing = false;
        }

        table.getmemberList(this.param).then(response=>{
          response.data.forEach(item=>{item.show=false})
          this.list=this.list.concat(response.data)
          this.loading = false;
          this.param.page++
          if (response.data.length <this.param.limit) {
            this.finished = true;
          }
        })

    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
    memberBlessing(item){
      console.log(item)
      this.$store.commit('updateRadioMember',item)
      this.$router.push('memberBlessing')
    }
  }
}
</script>
<style lang="scss" scoped>
  .member-wrap {
    .search{
      padding: 20px 30px;
      background: #fff;
      &-box{
        height: 60px;
        background: #F5F5F5;
        display: flex;
        align-items: center;
        border-radius: 30px;
        padding-left: 28px;

        /deep/ .van-field{
          width: 600px;
          input{background: #F5F5F5 !important;border-radius: 0}
        }
        /deep/ .van-cell::after {
          border-bottom:none;
        }
      }
    }
    .Glist{
      .title{
        font-size: 24px;
        color: #999;
        display: flex;
        justify-content: space-between;
        height: 80px;
        align-items: center;
        margin: 0 30px;
        i{color: #666;}
      }
      .column{
        padding:0 25px;
        background: #fff;
        margin: 0 30px 20px;
        border-radius: 16px;
        .caption{
          height: 100px;
          display: flex;
          justify-content:space-between;
          align-items: center;
          border-bottom: #F5F5F5 solid 2px;
          >div:nth-child(1){
            font-size: 36px;
            font-family: PingFang SC;
            font-weight: bold;
            color: #333333;
          }
          .caption-icon{
            width: 120px;
            display: flex;
            justify-content: space-between;
          }
        }
        .below{
          position: relative;
          text-align: center;
          font-size: 24px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 80px;
          .edit{
            position: absolute;
            top:0;
            right: 0;
            font-size: 28px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #4F57FB;
            .van-icon{
              margin-right: 10px;
            }
          }
        }
        .line{
          display: flex;
          justify-content: space-between;
          line-height: 60px;
          >div:nth-child(1){
            font-size: 28px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #999999;
          }
          >div:nth-child(2){
            text-align: right;
            flex:1;
            font-size: 28px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #333333;
          }
        }

      }
      .birthday{
        display: flex;
        align-items: center;
        justify-content: flex-end
      }
    }
  }
</style>
